import React from 'react'
import FileIcon from 'react-file-icon'
import { observer } from '../../../stores'
import iconStyles from './constants'

export interface PrettyFileIconProps {
  fileType: string | null | undefined
  size: number
}

export interface PrettyFileIconState {}

const PrettyFileIcon = observer((props: PrettyFileIconProps) => {
    const { fileType, size } = props
    return (
      <FileIcon
        extension={fileType}
        size={size}
        color="#f6e58d"
        // @ts-ignore
        {...iconStyles[fileType]}
      />
    )
})

export default PrettyFileIcon
